import { createApp, ref, onMounted, computed } from 'vue'

const app = createApp({
  setup() {
    const innerText = ref('') //初期読み込み時の文字数カウント用
    let textLength = ref(0) //現在の文字数
    let textDefference = ref(0) //最大文字数から現在の文字数を引き算した値
    const textOver = ref(false) //文字数オーバーかどうかの管理
    const textMax = 200 //最大文字数
    const fileSizeOver = ref(false) //ファイルサイズがオーバーかどうか
    const fileTypeStatement = ref(false) //ファイルの種類が適切かどうか
    const MBunit = 1048576 //MB数変換用

    // 画面読み込み時のテキストエリアの文字数をカウントする
    onMounted(() => {
      textLength.value = innerText.value.innerHTML.length
    })

    // テキストエリア入力時の文字数をカウントする
    const textChange = (event) => {
      textLength.value = event.target.value.length
      if (textLength.value > textMax) {
        textOver.value = true
        textDefference.value = event.target.value.length - textMax
      } else {
        textOver.value = false
      }
    }

    // 画像ファイル選択時に大きさとフォーマットをチェックする
    const imageChange = (event, MAXfileSize) => {
      if (event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png') {
        fileTypeStatement.value = false
      } else {
        fileTypeStatement.value = true
      }
      // console.log(fileTypeStatement.value)
      let fileSize = event.target.files[0].size / MBunit
      if (fileSize > MAXfileSize) {
        fileSizeOver.value = true
      } else {
        fileSizeOver.value = false
      }
      // console.log(fileSize)
    }

    // ボタンの状態を管理する(どちらか片方がtrueでボタンを押せなくする)
    const buttonStatement = computed(() => ({
      'c-button--false': fileSizeOver.value || textOver.value || fileTypeStatement.value
    }))

    return {
      innerText,
      textChange,
      textLength,
      textOver,
      textDefference,
      textMax,
      fileTypeStatement,
      fileSizeOver,
      imageChange,
      buttonStatement
    }
  }
})
if (document.getElementById('shopControl')) {
  app.mount('#shopControl')
}
